import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition,
    PropertyMappingType
} from "app/library/layout-builder";
import { ArtChildrenGalleryProps } from "./types";

export class ArtChildrenGalleryDefinitions extends CmsReactComponent<ArtChildrenGalleryProps> {
    static defaultProps = {};

    static schemaName = "art-children-gallery";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "year",
            text: "Yıl",
            mapping: {
                type: PropertyMappingType.Number
            },
            description: "Geçmiş yıl ise yazınız. Örn: 2019. Günümüz için boş bırakınız veya 0 yazınız.",
        },
        {
            name: "hero",
            mapping: {
                type: PropertyMappingType.Image,
            },
            description: "Hero görseli Desktop",
        },
        {
            name: "heroMobile",
            mapping: {
                type: PropertyMappingType.Image,
            },
            description: "Hero görseli Mobile",
        },
        {
            name: "photos",
            description: "Fotoğraf Galeri Elemanları",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        mapping: {
                            type: PropertyMappingType.Image
                        },
                        name: "thumbnail",
                        text: "Görsel Öne Çıkarılmış",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.Image
                        },
                        name: "src",
                        text: "Görsel Yolu",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.String
                        },
                        name: "alt",
                        text: "Görsel Alt Etiketi",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.String
                        },
                        name: "caption",
                        text: "Görsel Başlık",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.String
                        },
                        name: "subcaption",
                        text: "Görsel Alt Başlık",
                    },
                ]
            }
        },
        {
            name: "videos",
            description: "Video Galeri Elemanları",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        mapping: {
                            type: PropertyMappingType.Video
                        },
                        name: "src",
                        text: "Video yolu",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.String
                        },
                        name: "title",
                        text: "Video Başlık",
                    },
                ]
            }
        },
        {
            name: "photoPoster",
            mapping: {
                type: PropertyMappingType.Image,
            },
            description: "Öne çıkan fotoğraf galeri görsel",
        },
        {
            name: "videoPoster",
            mapping: {
                type: PropertyMappingType.Image,
            },
            description: "Öne çıkan video galeri görsel",
        },
        {
            name: "photoText",
            mapping: {
                type: PropertyMappingType.String,
            },
            description: "Fotoğraf galeri yazısı",
        },
        {
            name: "videoText",
            mapping: {
                type: PropertyMappingType.String,
            },
            description: "Video galeri yazısı",
        },
    ];
}
